import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';

import { NbButtonModule, NbCardModule } from '@nebular/theme';

@Component({
  selector: 'ngx-not-found',
  styleUrls: ['./not-found.component.scss'],
  templateUrl: './not-found.component.html',
  imports: [NbCardModule, NbButtonModule],
})
export class NotFoundComponent {
  private router = inject(Router);

  closeTab() {
    this.router.navigate(['./']);
  }
}
